import { createRouter, createWebHistory } from "vue-router";

//import Dashboard from "@/views/Dashboard.vue";
import Tables from "@/views/Tables.vue";
import Billing from "@/views/Billing.vue";
import Profile from "@/views/Profile.vue";
import Signup from "@/views/Signup.vue";
import Signin from "@/views/Signin.vue";
import Ping from "@/views/Ping.vue";
import ForgotPass from "@/views/ForgotPass.vue";

//import { nextTick } from 'vue';
import store from "../store";
import { registerChunkLoadHandlers } from "@/helpers/appUpdateCheck";

const authNotRequired = [
  '/signin',
  '/signup',
  '/ping',
  '/forgotpassword',
  '/share'
];

const authRequiredRoutes = store.state.auth.status.loggedIn === true || store ? [
  
  {
    path: "/",
    name: "Home",
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/filemanager",
    name: "File manager",
    component: () => import('@/views/filemanager/Filemanager.vue'),
  },
  {
    path: "/builder",
    name: "Ad builder",
    component: () => import('@/views/ad-builder/Home.vue'),
    children: [
      {
        path: "",
        name: "Creative builder",
        component: () => import('@/views/ad-builder/AdBuilder.vue'),
      },
    ]
  },
  {
    path: "/campaigns",
    name: "Campaigns",
    component: () => import('@/views/Campaigns.vue'),
    children: [
      {
        path: "",
        name: "Campaign list",
        component: () => import('@/views/ad-server/CampaignsList.vue'),
      },
      {
        path: ":campaignID",
        name: "Campaign",
        meta: {
          preventScroll: true // Prevent scroll when opening creative view
        },
        component: () => import('@/views/ad-server/CampaignContainer.vue'),
        children: [
          {
            path: "",
            name: "Campaign view",
            meta: {
              preventScroll: true // Prevent scroll when opening creative view
            },
            component: () => import('@/views/ad-server/CampaignView.vue')
          },
          {
            path: "reporting",
            name: "Campaign reporting",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          },
          {
            path: "reporting/bls",
            name: "Campaign BLS reporting",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          },
          {
            path: "reporting/creative/:creativeID",
            name: "Creative reporting",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          },
          {
            path: "creative/:creativeID",
            name: "Creative view",
            meta: {
              preventScroll: true // Prevent scroll when opening creative view
            },
            component: () => import('@/views/ad-server/CampaignView.vue') // it's broken, but anyways should have the creative open in the same view ;) so use the component in accordion
          }
        ]
      }
    ]
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import('@/views/admin/Admin.vue'),
    children: [
      { 
        path: '',
        name: 'User list',
        component: () => import('@/views/admin/List.vue'),
      },
      {
        path: "invite",
        name: "Invite new users",
        component: () => import('@/views/admin/Invite.vue'),
      },

    ]
  },
] : [];

const authNotRequiredRoutes = [
  {
    path: "/ping",
    name: "Ping",
    component: Ping,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/forgotpassword",
    name: "Forgot your password",
    component: ForgotPass,
  },
  {
    path: "/forgotpassword",
    name: "Forgot your password",
    component: ForgotPass,
  },
  {
    path: "/share",
    name: "Share campaigns",
    title: "Campaign reporting",
    component: () => import('@/views/Campaigns.vue'),
    children: [
      {
        path: ":shareToken",
        name: "Share campaign",
        component: () => import('@/views/ad-server/CampaignContainer.vue'),
        children: [
          {
            path: "",
            name: "Share campaign reporting",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          },
          {
            path: "bls",
            name: "Share campaign BLS",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          },
          {
            path: "creative/:creativeID",
            name: "Share creative reporting",
            component: () => import('@/views/ad-server/reporting/CampaignView.vue')
          }
        ]
      }
    ]
  }
];

const routes = [...authNotRequiredRoutes, ...authRequiredRoutes];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  linkActiveClass: "active",
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // This doesn't work with tables?
    console.log("Scroll behavior", to, from, savedPosition);

    let existing = {
      top: window.scrollY,
      left: window.scrollX,
      behavior: 'instant'
    };
    console.log(`Existing scroll`, existing);

    let output = {};

    if (to.meta.preventScroll && from.meta.preventScroll) {
      output = savedPosition || existing;
    } else if (savedPosition) {
      output = savedPosition;
    } else if (to.hash) {
      output = {
        el: to.hash
      }
    } else if (to.params && (to.params.selector || to.params.creativeID)) {
      output = {
        el: '#' + (to.params.selector || to.params.creativeID)
      }
    } else if (
      to.path == from.path || 
      to.matched[0] && from.matched[0] && to.matched[0].path == from.matched[0].path
    ) {
      output = existing;
    } else {
      return {}
    }

    // Return a promise that resolves after a short delay.
    // This gives the DOM time to update its height.
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(output);
      }, 0);
    });
  }
});

router.beforeEach((to, from, next) => {
  if (to.query && to.query.tab === 'bls') {
    const query = { ...to.query };
    delete query.tab;
    if (to.params.shareToken) {
      next({
        name: 'Share campaign BLS',
        params: { shareToken: to.params.shareToken },
        query,
        replace: true
      });
      return;
    }
    if (to.params.campaignID) {
      next({
        name: 'Campaign BLS reporting',
        params: { campaignID: to.params.campaignID },
        query,
        replace: true
      });
      return;
    }
  }
  let authRequired = true;
  authNotRequired.forEach((path) => {
    if (to.path.startsWith(path)) {
      //console.log("Not required",path,to.path)
      authRequired = false;
    }
  })
  //console.log("To",to,authRequired);
  if(to.path === '/' || to.path === '') {
    if (store.state.auth.status.loggedIn === true) {
      next('/dashboard');
    } else {
      if(authRequired) localStorage.setItem('afterLogin', to.fullPath);
      next('/signin');
    }

  } else if(authRequired) {
    if (store.state.auth.status.loggedIn === true) {
      next();
    } else {
      if(authRequired) localStorage.setItem('afterLogin', to.fullPath);
      next('/signin');
    }
  } else {
    if (to.path.startsWith('/share')) {
      store.state.showPrimaryNav = false;
      store.state.showHeaderInfo = false;
      store.state.showFooter = false;
    }
    next();
  }
  store.dispatch('auth/me').then(() => {
    if (authRequired && !store.state.auth.status.loggedIn) {
      router.push('/signin');
    }
  }).catch(() => {
    if (authRequired) {
      router.push('/signin');
    }

  });
})

registerChunkLoadHandlers(router);

export default router;
